import {random} from "lodash"

function makeConfetto() {
  const width = Math.random() * 8
  const height = width * 0.5
  const colours = [
    "confetti-yellow",
    "confetti-blue",
    "confetti-red",
    "confetti-green"
  ]
  const colour = colours[random(0, colours.length - 1)]
  const confetto = document.createElement("div")

  confetto.style.width = `${width}px`
  confetto.style.height = `${height}px`
  confetto.style.transform = `rotate(${Math.random() * 360}deg)`

  confetto.classList.add("confetti")
  confetto.classList.add(colour)

  return confetto
}

export function getConfetti(maxWidth, maxHeight, total = 20) {
  return Array
    .from(Array(total), (v, index) => index)
    .map((index) => {
      const confetto = makeConfetto()

      const tiltX = random(0, 60, true) * (index % 2 === 0 ? 1 : -1)

      const startX = random(0, maxWidth, true)
      const endX = startX + tiltX

      const startY = random(10, 100, true) * -1
      const endY = maxHeight + random(100, 200, true)

      return {
        confetto,
        startX,
        endX,
        startY,
        endY
      }
    })
}

export function fireConfetti(container, confetti) {
  return confetti.map(({confetto, startX, endX, startY, endY}) => {
    confetto.style.top = `${startY}px`
    confetto.style.left = `${startX}px`
    confetto.addEventListener("transitionend", () => {
      if (confetto.parentNode) {
        confetto.parentNode.removeChild(confetto)
      }
    })
    container.appendChild(confetto)

    return window.setTimeout(() => {
      confetto.style.top = `${endY}px`
      confetto.style.left = `${endX}px`
    }, random(0, 3000))
  })
}
